// Mock data for Internationale Christengemeinde Hannover

// Helper: Get next weekday date (0=Sunday, 1=Monday, ..., 6=Saturday)
function getNextWeekday(dayOfWeek) {
  const today = new Date();
  const diff = (dayOfWeek - today.getDay() + 7) % 7;
  const next = new Date(today);
  next.setDate(today.getDate() + (diff === 0 ? 7 : diff));
  return next.toISOString().split('T')[0];
}

// Helper: Get past Sunday dates (for sermons)
function getPastSunday(weeksAgo) {
  const today = new Date();
  const daysSinceSunday = today.getDay();
  const lastSunday = new Date(today);
  lastSunday.setDate(today.getDate() - daysSinceSunday - (weeksAgo * 7));
  return lastSunday.toISOString().split('T')[0];
}

// Helper: Format date as ISO string for next service
function getNextSundayISO() {
  const nextSun = new Date();
  const diff = (7 - nextSun.getDay()) % 7;
  nextSun.setDate(nextSun.getDate() + (diff === 0 ? 7 : diff));
  nextSun.setHours(16, 0, 0, 0);
  return nextSun.toISOString();
}

export const mockSermons = [
  {
    id: 'sermon-1',
    title: 'Glaube in unsicheren Zeiten',
    description: 'Eine ermutigende Botschaft über Vertrauen und Hoffnung, wenn das Leben unvorhersehbar wird.',
    speaker: 'ICG Hannover',
    date: getPastSunday(0),
    platform: 'youtube',
    videoId: 'dQw4w9WgXcQ',
    thumbnail: 'https://images.unsplash.com/photo-1698768676413-e49b729dafa6?w=800',
    duration: '45 Min',
    views: 234
  },
  {
    id: 'sermon-2',
    title: 'Die Kraft der Gemeinschaft',
    description: 'Warum wir einander brauchen und wie Gott uns durch Beziehungen stärkt.',
    speaker: 'ICG Hannover',
    date: getPastSunday(1),
    platform: 'vimeo',
    videoId: '123456789',
    thumbnail: 'https://images.unsplash.com/photo-1662151900393-97f6bc1567ef?w=800',
    duration: '38 Min',
    views: 189
  },
  {
    id: 'sermon-3',
    title: 'Liebe die nie aufhört',
    description: 'Eine tiefgehende Betrachtung über die bedingungslose Liebe Gottes zu uns Menschen.',
    speaker: 'ICG Hannover',
    date: getPastSunday(2),
    platform: 'youtube',
    videoId: 'dQw4w9WgXcQ',
    thumbnail: 'https://images.unsplash.com/photo-1622598453695-4fbaf151aadc?w=800',
    duration: '42 Min',
    views: 312
  },
  {
    id: 'sermon-4',
    title: 'Hoffnung für ein neues Jahr',
    description: 'Gottes Verheißungen und wie wir mit Zuversicht in die Zukunft blicken können.',
    speaker: 'ICG Hannover',
    date: getPastSunday(3),
    platform: 'youtube',
    videoId: 'dQw4w9WgXcQ',
    thumbnail: 'https://images.unsplash.com/photo-1769755411779-e4c43e7b7742?w=800',
    duration: '40 Min',
    views: 276
  }
];

export const mockEvents = [
  {
    id: 'event-1',
    title: 'Tauf-Unterricht',
    description: 'Vorbereitung auf die Taufe: Lerne die Bedeutung und den biblischen Hintergrund der Taufe kennen.',
    date: getNextWeekday(3),
    time: 'Mittwoch',
    location: 'Am Klagesmarkt 29, 30159 Hannover',
    category: 'Studium',
    recurring: 'Jeden Mittwoch',
    color: '#8b5cf6',
    image: 'https://images.unsplash.com/photo-1645620549807-0aea79c18482?w=800'
  },
  {
    id: 'event-2',
    title: 'Gebets- und Bibelstunde',
    description: 'Gemeinsames Gebet und vertieftes Bibelstudium in einer offenen und ermutigenden Atmosphäre.',
    date: getNextWeekday(4),
    time: 'Donnerstag',
    location: 'Am Klagesmarkt 29, 30159 Hannover',
    category: 'Gebet',
    recurring: 'Jeden Donnerstag',
    color: '#3b82f6',
    image: 'https://images.unsplash.com/photo-1437603568260-1950d3ca6eab?w=800'
  },
  {
    id: 'event-3',
    title: 'Gottesdienst',
    description: 'Unser wöchentlicher Gottesdienst mit Lobpreis, Predigt und Gemeinschaft. Vor Ort und im Live-Stream.',
    date: getNextWeekday(0),
    time: 'Sonntag · 16:00 Uhr',
    location: 'Am Klagesmarkt 29, 30159 Hannover',
    category: 'Gottesdienst',
    recurring: 'Jeden Sonntag',
    color: '#22c55e',
    image: 'https://images.unsplash.com/photo-1698768676413-e49b729dafa6?w=800'
  },
  {
    id: 'event-4',
    title: 'Youth Arise',
    description: 'Jugendgruppe der ICG Hannover: Gemeinschaft, Austausch und geistliche Impulse fuer junge Menschen.',
    date: getNextWeekday(6),
    time: 'Aktueller Termin',
    location: 'Am Klagesmarkt 29, 30159 Hannover',
    category: 'Jugend',
    recurring: 'Regelmäßig',
    color: '#f97316',
    image: 'https://images.unsplash.com/photo-1563902341721-029085ad9347?w=800'
  }
];

export const mockDailyVerse = {
  reference: 'Johannes 3:16',
  text: 'Denn so sehr hat Gott die Welt geliebt, dass er seinen eingeborenen Sohn gab, damit jeder, der an ihn glaubt, nicht verloren geht, sondern ewiges Leben hat.',
  translation: 'Lutherbibel 2017',
  date: new Date().toLocaleDateString('de-DE')
};

export const mockTeamMembers = [
  {
    id: 'team-3',
    name: 'Thomas Müller',
    role: 'Worship-Leiter',
    bio: 'Thomas führt unser Worship-Team und hat eine Leidenschaft für die Gegenwart Gottes.',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400'
  }
];

export const mockContactInfo = {
  address: 'Am Klagesmarkt 29, 30159 Hannover',
  phone: '+49 511 2773755',
  mobile: '+49 176 80022580',
  email: 'kontakt@icg-hannover.de',
  website: 'www.icg-hannover.de',
  socialMedia: {
    facebook: 'https://www.facebook.com/groups/1609376199309162',
    instagram: 'https://instagram.com/icg.hannover',
    youtube: 'https://youtube.com/@icg.hannover'
  }
};

export const mockLiveStream = {
  isLive: false,
  title: 'Live-Gottesdienst',
  streamUrl: 'https://youtube.com/live/...',
  schedule: 'Sonntags: 16:00 - 18:00 Uhr',
  nextService: getNextSundayISO()
};
